<template>
  <cardModel v-if="isLoginModelOpen" @close-card-model="closeLoginModel">
    <div class="login-model d-flex align-center ga-5">
      <div v-if="isLoginSideShow || isDesktop" class="login-side">
        <img class="tree-branch-top" src="@/assets/images/flowers.svg" />
        <img class="tree-branch-bottom" src="@/assets/images/flowers.svg" />
        <div class="content">
          <h1 class="title">{{ $t("Models.LoginModel.loginSide.title") }}</h1>
          <span class="sub-title">{{
            $t("Models.LoginModel.loginSide.subTitle")
          }}</span>
        </div>
        <LoginForm />
        <a
          v-if="isLoginSideShow && !isDesktop"
          class="text-decoration-underline w-100 mt-4 font-weight-light"
          @click.prevent="isLoginSideShow = false"
          >{{ $t("Models.LoginModel.loginSide.moveLink") }}</a
        >
      </div>
      <div v-if="!isLoginSideShow" class="register-side">
        <div class="content">
          <h1 class="title">
            {{ $t("Models.LoginModel.registerSide.title") }}
          </h1>
          <div class="sub-content">
            <p>{{ $t("Models.LoginModel.registerSide.paragraphOne") }}</p>
            <div class="dots d-flex flex-column justify-center">
              <p class="font-weight-bold">
                {{ $t("Models.LoginModel.registerSide.titleParagraphTwo") }}
              </p>
              <div class="dot d-flex ga-2">
                <v-icon :icon="dotIcon" />
                <span> {{ $t("Models.LoginModel.registerSide.dotOne") }} </span>
              </div>
              <div class="dot d-flex ga-2">
                <v-icon :icon="dotIcon" />
                <span> {{ $t("Models.LoginModel.registerSide.dotTwo") }} </span>
              </div>
              <div class="dot d-flex ga-2">
                <v-icon :icon="dotIcon" />
                <span>
                  {{ $t("Models.LoginModel.registerSide.dotThree") }}
                </span>
              </div>
            </div>
          </div>
          <div class="end-content">
            <p class="font-weight-bold">
              {{ $t("Models.LoginModel.registerSide.endParagraph") }}
            </p>
          </div>
          <v-btn
            color="#4FB989"
            @click.prevent="setLoginGuest"
            flat
            hide-details
            class="register-btn"
          >
            {{ $t("Models.LoginModel.registerSide.loginAsGuest") }}</v-btn
          >
          <a
            v-if="!isLoginSideShow && !isDesktop"
            class="text-decoration-underline w-100 mt-4 font-weight-light text-white"
            @click.prevent="isLoginSideShow = true"
            >{{ $t("Models.LoginModel.registerSide.moveLink") }}</a
          >
        </div>
      </div>
    </div>
  </cardModel>
</template>

<script>
import { mapGetters } from "vuex";
import LoginForm from "../../../menus/LoginForm.vue";
import cardModel from "../card-model.vue";
import { mapActions } from "vuex";

export default {
  components: { cardModel, LoginForm },
  emits: ["close-login-model"],
  data() {
    return {
      isLoginSideShow: false,
      dotIcon: "mdi-checkbox-marked-circle-outline",
    };
  },
  computed: {
    ...mapGetters({
      isMobile: "isMobile",
      isLaptop: "isLaptop",
      isTablet: "isTablet",
      isDesktop: "isDesktop",
      isAuthenticated: "AuthModule/isAuthenticated",
      isUserGuest: "AuthModule/isUserGuest",
      isLoginModelOpen: "AuthModule/isLoginModelOpen",
    }),
  },
  methods: {
    setLoginGuest() {
      // close the model
      //need to add the logic of local cart 
      this.setIsUserGuest(true);
      this.setLoginModel(false);
      // call to the getUserCart
      this.$store.dispatch("Orders/getUserCart");
    },
    ...mapActions({
      setLoginModel: "AuthModule/setLoginModel",
      setIsUserGuest: "AuthModule/setIsUserGuest",
    }),
    closeLoginModel() {
      this.$emit("close-login-model");
    },
  },
};
</script>

<style lang="scss">
.register-btn {
  width: fit-content;
  border-radius: 5px;
  height: 46px !important;
  font-weight: 300 !important;
  letter-spacing: 0 !important;
  font-size: $mediumTextSize !important;
}
</style>

<style scoped lang="scss">
a {
  cursor: pointer;
}
.login-model {
  height: 598px;
  position: relative;
  overflow: hidden;
}

@media (max-width: 1499px) {
  .login-model {
    height: 100%;
  }
}

.login-side {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: start;
  padding: 40px;
  padding-right: 60px;
  gap: 10px;
  width: calc(1024px - 450px);
  height: 100%;
  overflow: visible; /* Changed from hidden to visible */

  .tree-branch-top {
    position: absolute;
    transform: rotate(-779.847deg) scaleX(-1);
    left: 67px;
    top: -182px;
    z-index: 0; /* Changed z-index */
    height: auto;
    pointer-events: none; /* Added to prevent interaction issues */
  }

  .tree-branch-bottom {
    position: absolute;
    transform: rotate(119.102deg) scaleX(-1);
    right: -34px;
    bottom: -194px;
    z-index: 0; /* Changed z-index */
    height: auto;
    pointer-events: none; /* Added to prevent interaction issues */
  }

  .content {
    width: 100%;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    position: relative;
    z-index: 2; /* Ensure content stays above decorative elements */
    /* Rest of content styles remain the same */
    .title {
      font-size: $largTextSize;
      letter-spacing: 0;
      margin: 0;
    }

    .sub-title {
      font-size: $mediumTextSize;
      letter-spacing: 0;
      color: $subTextColor;
    }
  }
}

@media (max-width: 1499px) {
  .login-side {
    width: 100%;
    padding: 40px;

    .tree-branch-top {
      top: -230px;
    }

    .tree-branch-bottom {
      bottom: -220px;
    }
  }
}

@media (max-width: 601px) {
  .login-side {
    padding: 12px;
    padding-top: 40px;
  }
}

.register-side {
  position: relative;
  min-width: 450px;
  height: 100%;
  background-image: url("@/assets/images/register-background-side.png");
  background-size: cover;

  p,
  .dots {
    color: white;
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-width: 480px;
    text-align: start;
    .sub-content {
      margin-top: -20px;
      display: flex;
      font-size: 18px;
      flex-direction: column;
      gap: 20px;
    }
    .title {
      margin: 0px;
      color: white;
      font-size: 30px;
      letter-spacing: 0;
    }
    .question-mark {
      font-size: 60px;
    }
    padding: 40px;
  }

  @media (max-width: 1499px) {
    .content {
      width: 100%;
      position: unset;
    }
  }
}

@media (max-width: 1499px) {
  .register-side {
    min-width: unset;
    // padding: 50px;
    // padding-bottom: 100px;
  }
}

@media (max-width: 601px) {
  .register-side {
    min-width: unset;
    // padding: 25px;
    // padding-bottom: 100px;
    p,
    .end-content,
    .dot {
      font-size: 15px;
    }
    .title {
      font-size: 24px !important;
    }
  }
}
</style>
